<template>
  <div id="ThreeBottomContent">
    <c-block-box title="数字营销" class="first-floor-item-1">
      <div class="content-wrap">
        <div class="item-wrap item1-wrap">
          <p class="hd-title">营销概括 </p>
          <div class="item1-content item-content">
            <div class="item" v-for="(item,index) in DailyMarketingSummaryLists">
              <p class="name">{{ item.name }}</p>
              <div class="data-wrap">
                <span class="count BoldAlternate">{{ numberSplitWithComma(item.count) }}</span>
                <span class="icon">CPM</span>
              </div>
              <!-- <div class="super-name-wrap" v-if="index<2">
                <span class="super-name">本月新增</span>
                <span class="super-count">+1,201</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="item-wrap item2-wrap">
          <p class="hd-title">库存类型分布</p>
          <div class="item2-content item-content">
            <DomeEchartWrap ref="InventoryTypeDistribution" id="InventoryTypeDistributionEchartOp"></DomeEchartWrap>
            <div class="legend-warp">
              <div class="item" v-for="(item,index) in InventoryTypeDistributionLists">
                <span class="icon" :class="[`icon-${index + 1}`]"></span>
                <span class="name">{{ item.name }}</span>
                <span class="rate">{{ item.rate }}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="item-wrap item3-wrap">
          <p class="hd-title">热门城市</p>
          <div class="item3-content item-content">
            <!-- <DomeEchartWrap ref="PopularCities" id="PopularCities"></DomeEchartWrap> -->
            <div class="item item-progress-wrap" v-for="item in PopularCities">
              <div class="label-wrap">
                <span class="name">{{ item.name }}</span>
                <span class="kc">{{ numberSplitWithComma(item.count) }}</span>
                <!-- <span class="percent">{{ item.sellRate }}%</span> -->
              </div>
              <CcProgress
                :style-wrap="{
                  height: '0.3rem',
                  width: '100%',
                  'background-color': 'rgba(255,255,255,0.1)'
                }"
                :color="'linear-gradient(90deg, #412DD0 0%, #2BD6F9 100%)'"
                :num="+item.rate"
                :show-progress-count="false"
              ></CcProgress>
            </div>
          </div>
        </div>
        <div class="item-wrap item4-wrap">
          <p class="hd-title">热门人群标签</p>
          <div class="item4-content item-content" id="three-bot-item4-content">
            <DomeEchartWrap ref="PopularGroupLabel" id="PopularGroupLabel"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-wrap item5-wrap">
          <div>
            <p class="hd-title">营销方式</p>
            <div class="item5-content1 item-content" id="three-bot-item4-content">
              <div class="lists-wrap">
                <div class="item" v-for="(item,index) in saleTypeList">
                  <img :src="item.imgBase64" alt="" />
                  <div class="img-content">
                    <span class="name">{{ item.saleType }}</span>
                    <span class="little-title">
                      <span>曝光指数：</span>
                      <span class="count">
                        {{ item.exposeIndex }}
                        <!-- <span class="icon">次/台</span> -->
                      </span>
                    </span>
                  </div>
                </div>
                <!-- <div class="item" v-for="(item,index) in yxLists">
                  <img :src="getImg(index)" alt="" />
                  <div class="img-content">
                    <span class="name">{{ item.name }}</span>
                    <span class="little-title">
                      <span>{{ item.superName }}：</span>
                      <span class="count">
                        {{ item.count }}
                      </span>
                    </span>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div>
            <p class="hd-title">深度合作品牌</p>
            <div class="item5-content2 item-content" id="three-bot-item4-content">
              <div class="lists-wrap">
                <div class="item" v-for="(item,index) in DeepCooperationBrandImgLists">
                  <!-- <img :src="getImgHZ(index)" alt="" /> -->
                  <img :src="item" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item-wrap item6-wrap">
          <p class="hd-title">热门行业</p>
          <div class="item6-content item-content">
            <!-- <DomeEchartWrap ref="PopularCitiesNet" id="PopularCitiesNet"></DomeEchartWrap> -->
            <div class="item item-progress-wrap" v-for="item in PopularIndustryList">
              <div class="label-wrap">
                <span class="name">{{ item.name }}</span>
                <span class="kc">{{ numberSplitWithComma(item.count) }}</span>
                <!-- <span class="percent">{{ item.sellRate }}%</span> -->
              </div>
              <CcProgress
                :style-wrap="{
                  height: '0.3rem',
                  width: '100%',
                  'background-color': 'rgba(255,255,255,0.1)'
                }"
                :color="'linear-gradient(90deg, #412DD0 0%, #2BD6F9 100%)'"
                :num="+item.rate"
                :show-progress-count="false"
              ></CcProgress>
            </div>
          </div>
        </div>
        <div class="item-wrap item7-wrap">
          <p class="hd-title">行业投放趋势</p>
          <div class="item7-content item-content" id="three-bot-item4-content">
            <div class="item7-child-echart-item item7-child-echart-item1">
              <DomeEchartWrap ref="E-commerceIndustry" id="E-commerceIndustry"></DomeEchartWrap>
            </div>
            <div class="item7-child-echart-item item7-child-echart-item2">
              <DomeEchartWrap ref="FoodIndustry" id="FoodIndustry"></DomeEchartWrap>
            </div>
            <div class="item7-child-echart-item item7-child-echart-item3">
              <DomeEchartWrap ref="AutomobileIndustry" id="AutomobileIndustry"></DomeEchartWrap>
            </div>
            <div class="item7-child-echart-item item7-child-echart-item4">
              <DomeEchartWrap ref="AnalysisFamilyAudiencePreference" id="AnalysisFamilyAudiencePreference"></DomeEchartWrap>
            </div>
            <div class="item7-child-echart-item item7-child-echart-item5">
              <DomeEchartWrap ref="InteractiveBehaviorAnalysis" id="InteractiveBehaviorAnalysis"></DomeEchartWrap>
            </div>
          </div>
        </div>
      </div>
    </c-block-box>
  </div>
</template>

<script>
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import { PopularCitiesNetEchartOp, InteractiveBehaviorAnalysisEchartOp, AnalysisFamilyAudiencePreferenceEchartOp, AutomobileIndustryEchartOp, FoodIndustryEchartOp, ECommerceIndustryEchartOp, PopularGroupLabelEchartOp, InventoryTypeDistributionEchartOp, PopularCitiesEchartOp } from './js/ThreeFloorItem3'
import CcProgress from '@/components/DigitalMarketing/CcProgress'

import common from '@/mixins/common.js'

export default {
  mixins: [common],
  name: 'ThreeBottomContent',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      DailyMarketingSummaryLists: [
        {
          name: '营销库存量',
          count: 354746.84,
          countKey: 'stockCount'
        },
        {
          name: '日均库存耗量',
          count: 35803.73,
          countKey: 'exposureCount'
        }
      ],
      yxLists: [
        {
          name: '创意营销',
          superName: '曝光指数',
          count: 10,
          img: ''
        },
        {
          name: '内容营销',
          superName: '曝光指数',
          count: 9,
          img: ''
        },
        {
          name: '互动营销',
          superName: '曝光指数',
          count: 7,
          img: ''
        },
        {
          name: 'AI智能营销',
          superName: '曝光指数',
          count: 7,
          img: ''
        }
      ],
      DeepCooperationBrandImgLists: [
        {
          'value': 'http://134.175.223.4/video/10/cvte.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/feixun.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/coocaa.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/hbtv.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/jscn.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/ocn.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/panasonic.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/panda.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/philips.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/sccn.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/siviton.png'
        },
        {
          'value': 'http://134.175.223.4/video/10/skyworth.png'
        }
      ],
      saleTypeList: [],
      PopularCities: [],
      PopularIndustryList: [],
      InventoryTypeDistributionLists: []
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    let dom = document.getElementById('three-bot-item4-content')
    // this.$refs['InventoryTypeDistribution'].setEchartOption(InventoryTypeDistributionEchartOp({ v: this }))
  },
  watch: {
    data: {
      deep: true,
      handler: function (newValue, oldValue) {
        let { stockTypeList, hotCityList, focusPeopleList, focusIndustryList, mutualList, familyList, industryList, industryListMap, saleTypeList, deepBrandList } = newValue ?? {}
        this.$nextTick(() => {
          this.stockTypeList(stockTypeList)
          this.hotCityList(hotCityList)
          this.focusPeopleList(focusPeopleList)
          this.focusIndustryList(focusIndustryList)
          this.mutualList(mutualList)
          this.familyList(familyList)
          this.DailyMarketingSummaryListsInit(newValue)
          this.industryListMap(industryList, industryListMap)
          this.DeepCooperationBrandImgLists = deepBrandList
          this.saleTypeList = JSON.parse(JSON.stringify((saleTypeList ?? [])))?.reverse()
        })
      }
    }
  },
  methods: {
    industryListMap (mapList, val) {
      if (!mapList || !val) { return }
      let dataLists = []
      dataLists = mapList.map(name => {
        return val[name].data
      })
      this.$refs['E-commerceIndustry'].setEchartOption(ECommerceIndustryEchartOp({ v: this,
        data: {
          title: mapList[0],
          data: [...dataLists[0]]
        } }))
      this.$refs['FoodIndustry'].setEchartOption(FoodIndustryEchartOp({ v: this,
        data: {
          title: mapList[1],
          data: [...dataLists[1]]
        } }))
      this.$refs['AutomobileIndustry'].setEchartOption(AutomobileIndustryEchartOp({ v: this,
        data: {
          title: mapList[2],
          data: [...dataLists[2]]
        } }))
    },
    DailyMarketingSummaryListsInit (val) {
      this.DailyMarketingSummaryLists.forEach(item => {
        item.count = val?.[item.countKey] ?? 0
      })
    },
    getImg (index) {
      let imgNamelists = ['y-2', 'y-4', 'y-3', 'y-1']
      // return require(`@/assets/images/wujie_slices/y${index + 1}.png`)
      // return require(`@/assets/images/wujie_slices/y-${index + 1}.jpg`)
      return require(`@/assets/images/wujie_slices/${imgNamelists[index]}.jpg`)
    },
    getImgHZ (index) {
      let imgName = ['loreal', 'coco', 'ali', 'chanel', 'wph', 'xzld', 'SKII', 'Dior', 'benchi', 'bmw', 'mengniu', 'zg-nongyebank']
      return require(`@/assets/images/wujie_slices/${imgName[index]}.png`)
    },
    stockTypeList (val) {
      if (!val) { return }
      let data = []
      let total = val.reduce((a, b) => {
        a += parseInt(b.total)
        return a
      }, 0)
      let percentTotal = 0
      data = val.map(item => {
        let percent = ((item.total / total) * 100).toFixed(0)
        percentTotal += +percent
        return {
          name: item.spaceName,
          value: item.total,
          rate: percent
        }
      })

      data[data.length - 1].rate = 100 - percentTotal + (+data[data.length - 1].rate)
      this.InventoryTypeDistributionLists = data
      this.$refs['InventoryTypeDistribution'].setEchartOption(InventoryTypeDistributionEchartOp({ v: this, data, total: this.numberSplitWithComma(total) }))
    },
    hotCityList (val) {
      if (!val) { return }
      this.PopularCities = val.map(item => {
        return {
          name: item.cityName,
          count: item.total,
          rate: (item.total / val[0].total * 100).toFixed(2)
        }
      })
      // this.$refs['PopularCities'].setEchartOption(PopularCitiesEchartOp({ v: this, data: { data, name } }))
    },
    focusPeopleList (val) {
      if (!val) { return }
      let data = []
      data = val.map((item, index) => {
        return {
          name: item.tagName,
          value: item.pv,
          size: 40 - (index * 2)
        }
      })
      this.$refs['PopularGroupLabel'].setEchartOption(PopularGroupLabelEchartOp({ v: this, list: data }))
    },
    focusIndustryList (val) {
      if (!val) { return }
      this.PopularIndustryList = val.map(item => {
        return {
          name: item.insType,
          count: item.pv,
          rate: (item.pv / val[0].pv * 100).toFixed(2)
        }
      })
      // this.$refs['PopularIndustryList'].setEchartOption(PopularCitiesNetEchartOp({ v: this, data: { data, name } }))
    },
    mutualList (val) {
      if (!val) { return }
      let data = []
      let name = []
      val.forEach(item => {
        name.push(item.provicneName)
        data.push((item.rate * 100).toFixed(2))
      })
      this.$refs['InteractiveBehaviorAnalysis'].setEchartOption(InteractiveBehaviorAnalysisEchartOp({ v: this, data: { data, name } }))
    },
    familyList (val) {
      if (!val) { return }
      let data = []
      let name = []
      val.forEach(item => {
        name.push(item.tagName)
        data.push(item.pv)
      })
      this.$refs['AnalysisFamilyAudiencePreference'].setEchartOption(AnalysisFamilyAudiencePreferenceEchartOp({ v: this, data: { data, name } }))
    }
  },
  components: {
    DomeEchartWrap,
    CcProgress
  }
}
</script>

<style scoped lang="stylus">
.content-wrap
  padding: 1.5rem 2rem
  display: flex
  justify-content: space-between
  height: 28.2rem
  .hd-title
    font-size: 1.3rem
    margin-bottom 1.5rem
    color rgba(255, 255, 255, 1)
  .item-wrap
    height 24rem
    display: flex
    flex-direction: column
    .item1-content
      color rgba(255, 255, 255, 1)
      .name
        margin-bottom: .4rem
      .count
        font-size: 1.55rem
        margin-left: 0.2rem
      .icon
        font-size: 0.55rem
      .item+.item
        margin-top: 1rem
    .item-content
      flex-grow: 1
  .item3-wrap,.item4-wrap,.item6-wrap
    width 12rem
  .item5-wrap
    width 20rem
  .item7-content
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    width 36rem
  .item7-child-echart-item1,.item7-child-echart-item2,.item7-child-echart-item3
    width 12rem
    height 10rem
    margin-bottom: 1rem
  .item7-child-echart-item4,.item7-child-echart-item5
    width 17.8rem
    height 10rem

.item5-content1
  margin-bottom: 1.5rem
  .lists-wrap
    display: flex
    justify-content: space-between
  .item
    height 7rem
    width 4.6rem
    position: relative
    background-color:RGBA(54, 62, 102, 1)
    img
      height 4.6rem
      width 4.6rem
      margin-bottom: .4rem
      display: inline-block
    .img-content
      padding: 0.2rem
      font-size: .6rem
      padding .1rem
      transform:  scale(.9)
      color rgba(255, 255, 255, 1)
      .little-title
        font-size: .45rem
        display flex
        .count
          display: flex
        .icon
          font-size: .25rem
          transform: scale(.5)
      .name
        margin-bottom: .25rem
      span
        display inline-block
        white-space: nowrap
.item5-content2
  .lists-wrap
    display: flex
    justify-content: space-between
    flex-wrap: wrap
  .item
    height 2.95rem
    width 4.6rem
    img
      height 100%
      width 100%
  .item:nth-of-type(n+5)
    margin-top: .5rem

.item2-content
  display: flex
  flex-direction: column
  width 10rem
  .legend-warp
    width 100%
    .item
      display: flex
      align-items: center
      padding: .25rem 0
      border-bottom: 0.05rem solid rgba(255, 255, 255, 0.1);
      > span
          display inline-block
      .icon
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 0.1rem;
        margin-right .5rem
      .icon-1
        background: linear-gradient(45deg, #025EE2 0%, #29BAFF 100%);
      .icon-2
        background: linear-gradient(225deg, #B945F5 0%, #565BFE 100%);
      .icon-3
        background: linear-gradient(45deg, #FF33CB 0%, #FA7481 100%);
      .icon-4
        background: linear-gradient(45deg, #37B4EE 0%, #3AF1C3 100%);
      .icon-5
        background: linear-gradient(225deg, #D2ED1B 0%, #86F61D 100%);
      .name
        font-size: .7rem
        color: rgba(255, 255, 255, 0.8);
      .rate
        font-size:1.2rem
        color rgba(255, 255, 255, 1)
        margin-left: auto
  #InventoryTypeDistributionEchartOp
    height: 10rem
    margin-bottom: 1.5rem
</style>
